/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DashboardDailyMessagesViewModel } from "../types/DashboardDailyMessagesViewModel.ts";

export const dashboardDailyMessagesViewModelSchema = z.object({
  date: z.string().nullish(),
  messages: z.optional(z.number().int()),
}) as unknown as ToZod<DashboardDailyMessagesViewModel>;
